type Options = {
  applicationKey: string;
  endpoint?: string;
  m: string;
  play?: number;
  title?: string | number;
  brand?: number;
  hl?: number;
  tourcta?: number;
  dh?: number;
  mt?: number;
  nozoom?: number;
  pin?: number;
  mls?: number;
  qs?: number;
  gt?: number;
  portal?: number;
  f?: number;
  wh?: number;
  kb?: number;
  lp?: number;
  vr?: number;
  ts?: number;
  help?: number;
  nt?: number;
  newtags?: number;
  search?: number;
  ss?: string;
  sr?: string;
  useLegacyIds?: number;
};

const defaultOptions = {
  endpoint: '',
  title: 0,
  brand: false,
  hl: 0,
  tourcta: 1,
  dh: true,
  mt: true,
  nozoom: true,
  pin: true,
  mls: 0,
  qs: false,
  gt: true,
  portal: true,
  f: true,
  wh: true,
  kb: true,
  lp: false,
  vr: true,
  ts: -1,
  help: -1,
  nt: false,
  play: 1,
  newtags: 1,
  search: 0,
};

export const buildIframeSdkUrl = (version: string, options: Options) => {
  const query = new URLSearchParams();
  Object.entries({ ...defaultOptions, ...options }).forEach(
    ([key, value]: [keyof Options, string | number]) => {
      if (key !== 'endpoint') {
        query.append(key, value.toString());
      }
    },
  );
  return `${options.endpoint || ''}/mp-sdk/${version}/showcase.html?${query.toString()}`;
};
